
const SeStatus = {
  success: 'success',
  error: 'error',
  loading: 'loading'
}

const SeRequestType = {
  rtImport: 'Import',
  rtNewData: 'NewEvaluation',
  rtExport: 'Export',
  rtCopy: 'Copy',
  rtUpdate: 'Update',
  rtViewFindings: 'ViewFindings'
}

const SeEvaluationDataSourceType = {
  dsClone: 'Clone',
  dsImport: 'Import',
  dsManual: 'ManualEntry',
}

const SeEmploymentType = {
  primary: 'Primary',
  secondary: 'Secondary'
}

const SeEmploymentClassificationType = {
  borrowerPrimaryIncomeSource: 'borrowerPrimaryIncomeSource',
  borrowerSecondaryIncomeSourceWithPrimarySE: 'borrowerSecondaryIncomeSourceWithPrimarySE',
  borrowerSecondaryIncomeSourceWithPrimaryNotSE: 'borrowerSecondaryIncomeSourceWithPrimaryNotSE'
}

const SeUserType = {
  utBorrower: 'Borrower',
  utBrokerLender: 'BrokerLender',
  utOther: 'Other',
  utDeclined: 'Declined'
}

const SeYesNoType = {
  Yes: 'Yes',
  No: 'No'
}

const SeIncomeTypeType = {
  selfEmployed: 'selfEmployed',
  rental: 'rental',
  wageEarner: 'wageEarner'
}

const SeRentalIncomeIrsFormType = {
  businessTaxReturns: 'businessTaxReturns',
  scheduleEPart1: 'scheduleEPart1'
}

const SeTaxFormType = {
  tf1040: '1040',
  tf1040sr: '1040SR',
  tf1040nr: '1040NR',
  tf1065: '1065',
  tf1120: '1120',
  tf1120s: '1120S',
  tf1040c: '1040_SCH_C',
  tf1040s1: '1040_SCH_1',
  tf1040se: '1040_SCH_E',
  tf4684: '4684',
  tf4562: '4562',
  tf8825: '8825',
  tf1065sk1: '1065_SCH_K1',
  tf1065sm3: '1065_SCH_M3',
  tf1120ssk: '1120S_SCH_K1',
  tf1120sm3: '1120S_SCH_M3',
  tf1120m3: '1120_SCH_M3',
  tf1125e: '1125E',
  tfw2: 'W2',
  tf8582: '8582',
  tfLossesExpenses: 'LOSSES_EXPENSES',
}

const SeBusinessStructureType= {
  rental: { id: "rental", name: "Rental", derivedName: "Rental Income" },
  soleProprietorship: { id: "soleProprietorship", name: "Sole Proprietorship (Schedule C)", derivedName: "Sole Proprietorship" },
  sCorp: { id: "sCorp", name: "S Corporation", derivedName: "S-Corporation" },
  partnership: { id: "partnership", name: "Partnership", derivedName: "Partnership" },
  corp: { id: "corp", name: "Corporation", derivedName: "Corporation" },
  llc: { id: "llc", name: "Limited Liability Company (LLC)", derivedName: "LLC" },
  unknown: { id: "unknown", name: "I don't know", derivedName: "Unknown" }
}

const EmploymentOwnershipInterestProvidedType = {
  gte25: 'greaterThanOrEqualTo25Percent',
  lt25: 'lessThan25Percent'
}

const SeEvalRequestYearsType = {
  oneYr: "OneYr",
  twoYrs: "TwoYrs",
  oneYrPersonal: "OneYrPersonal",
  twoYrsPersonal: "TwoYrsPersonal",
  oneYrPersonalOneYrBusiness: "OneYrPersonalOneYrBusiness",
  twoYrsPersonalTwoYrsBusiness: "TwoYrsPersonalTwoYrsBusiness",
  perDuRequirement: "PerDuRequirement",
  unknown: "Unknown"
}

const SeRentalPropertyType= {
  singleFamilyResidence: {id: "singleFamilyResidence", label: "1  Single Family Residence"},
  multiFamilyResidence: {id: "multiFamilyResidence", label: "2  Multi-Family Residence"},
  vacationShortTerm: {id: "vacationShortTerm", label: "3  Vacation/Short-Term Rental"},
  commercial: {id: "commercial", label: "4  Commercial"},
  land: {id: "land", label: "5  Land"},
  royalties: {id: "royalties", label: "6  Royalties"},
  selfRental: {id: "selfRental", label: "7  Self-Rental"},
  other: {id: "other", label: "8  Other"}
}

const SeFairRentalDaysLessThan365DetailType= {
  acquiredDuringTaxYear: "acquiredDuringTaxYear",
  rehabilitationRenovation: "rehabilitationRenovation",
  unknown: "unknown"
}

const SeRentalMonthlyQualifiedIncomeZeroMemos = [
  'RENTAL-INCOME-NOT-PERMITTED-URLA-ENTRY',
  'RENTAL-INCOME-ZERO-POSITIVE-CASH-FLOW-URLA-ENTRY'
]

const SeAdjustedRentalIncomeMemos = [
  'RENTAL-HOUSING-EXPENSE-NEGATIVE-OR-MISSING',
  'RENTS-RECEIVED-NEGATIVE-OR MISSING-SCHE',
  'ACCESSORY-BOARDER-GREATER-THAN-RENT-CURRENT-YEAR',
  'DEDUCTIBLE-MORTGAGE-INTEREST-GREATER-THAN-OTHER-INTEREST-CURRENT-YEAR'
]

const SeMonthlyQualifiedIncomeZeroMemos = [
  'SCHEDULEC-BUSINESS-AGE-LT12-MONTHS-CURRENT-YEAR',
  'BUSINESS-STRUCTURE-CHANGE',
  'EMPLOYMENT-LESS-THAN-24-MONTHS-INCONSISTENT-HISTORY',
  'SCORPORATION-BUSINESS-AGE-LT12-MONTHS-CURRENT-YEAR',
  'EMPLOYMENT-LESS-THAN-12-MONTHS',
  'FINAL-RETURN',
  'FISCAL-YEAR',
  'BUSINESS-OWNERSHIP-PERCENT-NULL-PRIOR-YEAR',
  'K1-NET-RENTAL-INCOME',
  'K1-NAME-TRUST-BORROWER-NOT-GRANTOR',
  'PARTNERSHIP-BUSINESS-AGE-LT12-MONTHS-CURRENT-YEAR',
  'K1-PARTNERSHIP-PERCENT-LESS-THAN-25-CURRENT-YEAR',
  'BUSINESS-OWNERSHIP-PERCENT-NULL-PRIOR-YEAR',
  'CORPORATION-BUSINESS-AGE-LT12-MONTHS-CURRENT-YEAR',
  'COMMON-STOCK-PERCENT-LESS-THAN-25-CURRENT-YEAR',
  'OWNERSHIP-SHARE-BUSINESS-RETURNS-INCONSISTENT',
  'ONE-YEAR-RETURNS-LESS-THAN-25-PERCENT-OWNERSHIP',
  'EMPLOYMENT-LESS-THAN-24-MONTHS-LESS-THAN-25-PCT-OWNERSHIP',
  'K1-OWNERSHIP-PERCENT-MISSING'
]

const SePYQualifiedIncomeZeroMemos = [
  'PRIOR-YEAR-INCOME-NOT-INCLUDED-REASON-DECLINING-INCOME',
  'K1-SHAREHOLDER-PERCENT-LESS-THAN-25-PRIOR-YEAR',
  'K1-PARTNERSHIP-PERCENT-LESS-THAN-25-PRIOR-YEAR',
  'COMMON-STOCK-PERCENT-LESS-THAN-25-PRIOR-YEAR'
]

const SeFindingsSummaryRentalSchELineType= {
  fairRentalDaysCount: {
    id: "fairRentalDaysCount", name: "Fair Rental Days",
    memoCy: ['FAIR-RENTAL-DAYS-ALTERNATIVE-SOURCE', 'FAIR-RENTAL-DAYS-DEFAULT', 'FAIR-RENTAL-DAYS-LT365-UNKNOWN-REASON', 'FAIR-RENTAL-DAYS-RENO-NOT-SUPPORTED-BY-REPAIRS']
  },
  rentsReceived: { id: "rentsReceived", name: "Rents Received"},
  rentalPropertyAccessoryBoarderIncome: { id: "rentalPropertyAccessoryBoarderIncome", name: "Accessory Unit or Boarder Income",
    memoCy: ['RENTAL-PROPERTY-ACCESSORY-UNIT-BOARDER-INCOME']
  },
  rentalPropertyTotalExpenses: { id: "rentalPropertyTotalExpenses", name: "Total Expenses"},
  rentalPropertyInsurance: { id: "rentalPropertyInsurance", name: "Insurance"},
  rentalPropertyMortgageInterestPaidToBanks: { id: "rentalPropertyMortgageInterestPaidToBanks", name: "Mortgage Interest Paid to Banks"},
  rentalPropertyOtherDeductibleMortgageInterest: { id: "rentalPropertyOtherDeductibleMortgageInterest", name: "Other Deductible Mortgage Interest"},
  rentalPropertyTax: { id: "rentalPropertyTax", name: "Taxes"},
  rentalPropertyHomeownersAssociationDues: { id: "rentalPropertyHomeownersAssociationDues", name: "Homeowners Association Dues"},
  rentalPropertyIndividualPropertyDepreciation: { id: "rentalPropertyIndividualPropertyDepreciation", name: "Depreciation/Depletion"},
  casualtyTheftLoss: { id: "casualtyTheftLoss", name: "Casualty/theft loss"},
  extraordinaryOneTimeExpenses: { id: "extraordinaryOneTimeExpenses", name: "Extraordinary one-time expenses"}
}

const SeFindingsSummaryLineType= {
  netProfitLoss: { id: "netProfitLoss", name: "Net profit (or loss)"},
  otherIncomeLoss: { id: "otherIncomeLoss", name: "Other Income",
    memoCy:['OTHER-INCOME-SCHEDULEC-ZERO', 'OTHER-INCOME-SCHEDULEC-NONRECURRING'],
    memoPy:['OTHER-INCOME-SCHEDULEC-ZERO', 'OTHER-INCOME-SCHEDULEC-NONRECURRING']
  },
  depletion: { id: "depletion", name: "Depletion"},
  depreciation: { id: "depreciation", name: "Depreciation (standard)"},
  vehicleDepreciation: { id: "vehicleDepreciation", name: "Vehicle Depreciation (mileage method)",
    memoCy:['MILEAGE-DEPRECIATION-SCHEDULEC-MISMATCH-CURRENT-YEAR', 'MILEAGE-DEPRECIATION-INCLUDED-IN-SCHEDULEC-CURRENT-YEAR'],
    memoPy:['MILEAGE-DEPRECIATION-SCHEDULEC-MISMATCH-PRIOR-YEAR', 'MILEAGE-DEPRECIATION-INCLUDED-IN-SCHEDULEC-PRIOR-YEAR']
  },
  deductibleMeals: { id: "deductibleMeals", name: "Deductible meals"},
  nonDeductibleMeals: { id: "nonDeductibleMeals", name: "Nondeductible meals",
    memoCy:['SCHEDULEC-NONDEDUCTIBLE-MEALS-DOCUMENTATION', 'SCHEDULEC-DEDUCTIBLE-MEALS-MISSING', 'SCHEDULEC-NONDEDUCTIBLE-MEALS-NEGATIVE', 'SCHEDULEC-DEDUCTIBLE-MEALS-INCONSISTENT', 'SCHEDULEC-NONDEDUCTIBLE-MEALS-EXCEEDS-DEDUCTIBLE-CURRENT-YEAR'],
    memoPy:['SCHEDULEC-NONDEDUCTIBLE-MEALS-DOCUMENTATION', 'SCHEDULEC-DEDUCTIBLE-MEALS-MISSING', 'SCHEDULEC-NONDEDUCTIBLE-MEALS-NEGATIVE', 'SCHEDULEC-DEDUCTIBLE-MEALS-INCONSISTENT', 'SCHEDULEC-NONDEDUCTIBLE-MEALS-EXCEEDS-DEDUCTIBLE-PRIOR-YEAR']
  },
  businessUseHome: { id: "businessUseHome", name: "Business use of home"},
  amortization: { id: "amortization", name: "Amortization (Schedule C)"},
  amortization4562: { id: "amortization4562", name: "Amortization (4562)"},
  casualtyTheftLoss: { id: "casualtyTheftLoss", name: "Casualty/theft loss"},
  extraordinaryOneTimeExpenses: { id: "extraordinaryOneTimeExpenses", name: "Extraordinary one-time expenses"},
  w2MedicareWages: { id: "w2MedicareWages", name: "W-2 Medicare wages"},
}

const SeFindingsSummarySCorpLineType = {
  ordinaryBusinessIncomeLoss: { id: "ordinaryBusinessIncomeLoss", name: "Ordinary business income (loss)"},
  netRentalRealEstateIncomeLoss: { id: "netRentalRealEstateIncomeLoss", name: "Net rental real estate income (loss)"},
  otherNetRentalIncomeLoss: { id: "otherNetRentalIncomeLoss", name: "Other net rental income (loss)"},
  k1Income: { id: "k1Income", name: "K-1 Income"},
  k1Distribution: { id: "k1Distribution", fieldId: "itemsAffectingShareholderBasisCodeDAmount", name: "K-1 Distributions"},
  businessIncomeTitle: { id: "businessIncomeTitle", name: "Business Income from Form 1120S", hideLt25: true},
  netGainLoss4797: { id: "netGainLoss4797", name: "Form 4797 gain (loss)",
    memoCy:['4797-GAIN-LOSS-SCORPORATION-ZERO', '4797-GAIN-LOSS-SCORPORATION-NONRECURRING'],
    memoPy:['4797-GAIN-LOSS-SCORPORATION-ZERO', '4797-GAIN-LOSS-SCORPORATION-NONRECURRING'],
    hideLt25: true
  },
  otherIncomeLoss: { id: "otherIncomeLoss", fieldId: "otherIncomeLoss", name: "Other income (loss)",
    memoCy:['OTHER-INCOME-SCORPORATION-ZERO', 'OTHER-INCOME-SCORPORATION-NONRECURRING'],
    memoPy:['OTHER-INCOME-SCORPORATION-ZERO', 'OTHER-INCOME-SCORPORATION-NONRECURRING'],
    hideLt25: true
  },
  depreciation: { id: "depreciation", name: "Depreciation (1120S)", hideLt25: true},
  depreciation8825: { id: "depreciation8825", fieldId: "depreciation", name: "Depreciation (8825)", hideLt25: true},
  depletion: { id: "depletion", name: "Depletion", hideLt25: true},
  amortization: { id: "amortization", name: "Amortization (1120S)", hideLt25: true},
  amortization4562: { id: "amortization4562", fieldId: "amortization4562", name: "Amortization (4562)", hideLt25: true},
  casualtyTheftLoss: { id: "casualtyTheftLoss", name: "Casualty/theft loss", hideLt25: true},
  extraordinaryOneTimeExpenses: { id: "extraordinaryOneTimeExpenses", name: "Extraordinary one-time expenses", hideLt25: true},
  mortgagesNotesPayableLessThanOneYearEndOfYear: { id: "mortgagesNotesPayableLessThanOneYearEndOfYear", fieldId: "mortgagesNotesPayableLess1YrEndOfTaxYear", name: "Mortgages, notes or bonds payable in less than 1 year",
    memoCy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-CURRENT-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-SCORPORATION-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH'],
    memoPy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-PRIOR-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-SCORPORATION-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH'],
    hideLt25: true
  },
  travelEntertainment: { id: "travelEntertainment", name: "Travel and entertainment (M-1)", changeOverYearFromTaxReturn: true, hideLt25: true},
  deductibleMeals: { id: "deductibleMeals", fieldId: "mealsAndEntertainment", name: "Meals and entertainment (M-3)", changeOverYearFromTaxReturn: true, hideLt25: true},
  totalBusinessIncome: { id: "totalBusinessIncome", name: "Subtotal Business Income", hideLt25: true},
  totalRentalIncome: { id: "totalRentalIncome", name: "Subtotal Rental Property Income", hideLt25: true},
  ownershipPercent: { id: "ownershipPercent", fieldId: "cyAllocationPercentage", name: "Borrower's Ownership Percent", hideLt25: true},
  totalBusinessIncomeShare: { id: "totalBusinessIncomeShare", name: "Borrower's Share of Business Income", hideLt25: true},
  w2MedicareWages: { id: "w2MedicareWages", name: "W-2 Medicare wages"},
  compensationOfOfficers: { id: "compensationOfOfficers", name: "Compensation of Officers",
    memoCy:['COMPENSATION-OF-OFFICERS-NOT-ON-1040'],
    memoPy:['COMPENSATION-OF-OFFICERS-NOT-ON-1040']
  },
  distributionGuaranteedPaymentOrK1Income: { id: "distributionGuaranteedPaymentOrK1Income", name: "K-1 Income or Distributions (from above)"},
}

const SeFindingsSummaryPartnershipLineType = {
  ordinaryBusinessIncomeLoss: { id: "ordinaryBusinessIncomeLoss", name: "Ordinary business income (loss)"},
  netRentalRealEstateIncomeLoss: { id: "netRentalRealEstateIncomeLoss", name: "Net rental real estate income (loss)"},
  otherNetRentalIncomeLoss: { id: "otherNetRentalIncomeLoss", name: "Other net rental income (loss)"},
  k1Income: { id: "k1Income", name: "K-1 Income"},
  k1Distribution: { id: "k1Distribution", fieldId: "distributionCodeAAmount", name: "K-1 Distributions"},
  guaranteedPaymentsForServices: { id: "guaranteedPaymentsForServices", name: "Guaranteed Payments to Partners For Services"},
  guaranteedPaymentsForCapital: { id: "guaranteedPaymentsForCapital", name: "Guaranteed Payments to Partners For Capital"},
  totalGuaranteedPayments1: { id: "totalGuaranteedPayments1", fieldId: "totalCalculatedGuaranteedPayments", name: "Total Guaranteed Payments to Partners", responseFieldId: "totalCalculatedGuaranteedPayments"},
  businessIncomeTitle: { id: "businessIncomeTitle", name: "Business Income from Form 1065", hideLt25: true},
  ordinaryIncomeLossFromOtherPartnershipsEstates: { id: "ordinaryIncomeLossFromOtherPartnershipsEstates", name: "Ordinary Income from Other Partnerships Estates and Trusts",
    memoCy:['OTHER-PARTNERSHIP-ESTATE-TRUST-ZERO', 'OTHER-PARTNERSHIP-ESTATE-TRUST-NONRECURRING'],
    memoPy:['OTHER-PARTNERSHIP-ESTATE-TRUST-ZERO', 'OTHER-PARTNERSHIP-ESTATE-TRUST-NONRECURRING'],
    hideLt25: true
  },
  netGainLoss4797: { id: "netGainLoss4797", name: "Form 4797 gain (loss)",
    memoCy:['4797-GAIN-LOSS-PARTNERSHIP-ZERO', '4797-GAIN-LOSS-PARTNERSHIP-NONRECURRING'],
    memoPy:['4797-GAIN-LOSS-PARTNERSHIP-ZERO', '4797-GAIN-LOSS-PARTNERSHIP-NONRECURRING'],
    hideLt25: true
  },
  netFarmGainLoss: { id: "netFarmGainLoss", fieldId: "netFarmProfitLoss", name: "Farm profit (loss)",
    memoCy:['FARM-PROFIT-LOSS-PARTNERSHIP-ZERO', 'FARM-PROFIT-LOSS-PARTNERSHIP-NONRECURRING'],
    memoPy:['FARM-PROFIT-LOSS-PARTNERSHIP-ZERO', 'FARM-PROFIT-LOSS-PARTNERSHIP-NONRECURRING'],
    hideLt25: true
  },
  otherIncomeLoss: { id: "otherIncomeLoss", fieldId: "otherIncomeLoss", name: "Other income (loss)",
    memoCy:['OTHER-INCOME-PARTNERSHIP-ZERO', 'OTHER-INCOME-PARTNERSHIP-NONRECURRING'],
    memoPy:['OTHER-INCOME-PARTNERSHIP-ZERO', 'OTHER-INCOME-PARTNERSHIP-NONRECURRING'],
    hideLt25: true
  },
  depreciation: { id: "depreciation", name: "Depreciation (1065)", hideLt25: true},
  depreciation8825: { id: "depreciation8825", fieldId: "depreciation", name: "Depreciation (8825)", hideLt25: true},
  depletion: { id: "depletion", name: "Depletion", hideLt25: true},
  amortization: { id: "amortization", name: "Amortization (1065)", hideLt25: true},
  amortization4562: { id: "amortization4562", fieldId: "amortization4562", name: "Amortization (4562)", hideLt25: true},
  casualtyTheftLoss: { id: "casualtyTheftLoss", name: "Casualty/theft loss", hideLt25: true},
  extraordinaryOneTimeExpenses: { id: "extraordinaryOneTimeExpenses", name: "Extraordinary one-time expenses", hideLt25: true},
  mortgagesNotesPayableLessThanOneYearEndOfYear: { id: "mortgagesNotesPayableLessThanOneYearEndOfYear", fieldId: "mortgagesNotesPayableLess1YrEndOfTaxYear", name: "Mortgages, notes or bonds payable in less than 1 year",
    memoCy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-CURRENT-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-PARTNERSHIP-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH'],
    memoPy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-PRIOR-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-PARTNERSHIP-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH'],
    hideLt25: true
  },
  travelEntertainment: { id: "travelEntertainment", name: "Travel and entertainment (M-1)", changeOverYearFromTaxReturn: true, hideLt25: true},
  deductibleMeals: { id: "deductibleMeals", fieldId: "mealsAndEntertainment", name: "Meals and entertainment (M-3)", changeOverYearFromTaxReturn: true, hideLt25: true},
  totalBusinessIncome: { id: "totalBusinessIncome", name: "Subtotal Business Income", hideLt25: true},
  totalRentalIncome: { id: "totalRentalIncome", name: "Subtotal Rental Property Income", hideLt25: true},
  ownershipPercent: { id: "ownershipPercent", fieldId: "partnerShareOfCapitalEndingPct", name: "Borrower's Ownership Percent", hideLt25: true},
  totalBusinessIncomeShare: { id: "totalBusinessIncomeShare", name: "Borrower's Share of Business Income", hideLt25: true},
  totalGuaranteedPayments2: { id: "totalGuaranteedPayments2", name: "Total Guaranteed Payments to Partners", hideLt25: true, responseFieldId: "totalCalculatedGuaranteedPayments"},
  w2MedicareWages: { id: "w2MedicareWages", name: "W-2 Medicare wages"},
  distributionGuaranteedPaymentOrK1Income: { id: "distributionGuaranteedPaymentOrK1Income", name: "K-1 Income or Distributions (from above)"},
}

const SeFindingsSummaryCorpLineType = {
  taxableIncome: { id: "taxableIncome", name: "Taxable income"},
  totalTax: { id: "totalTax", name: "Total tax"},
  capitalGainNetIncome: { id: "capitalGainNetIncome", name: "Capital gain (loss)",
    memoCy:['CAPITAL-GAIN-LOSS-CORPORATION-ZERO', 'CAPITAL-GAIN-LOSS-CORPORATION-NONRECURRING'],
    memoPy:['CAPITAL-GAIN-LOSS-CORPORATION-ZERO', 'CAPITAL-GAIN-LOSS-CORPORATION-NONRECURRING']
  },
  netGainLoss4797: { id: "netGainLoss4797", name: "Form 4797 gain (loss)",
    memoCy:['4797-GAIN-LOSS-CORPORATION-ZERO', '4797-GAIN-LOSS-CORPORATION-NONRECURRING'],
    memoPy:['4797-GAIN-LOSS-CORPORATION-ZERO', '4797-GAIN-LOSS-CORPORATION-NONRECURRING']
  },
  otherIncomeLoss: { id: "otherIncomeLoss", fieldId: "otherIncomeLoss", name: "Other income (loss)",
    memoCy:['OTHER-INCOME-CORPORATION-ZERO', 'OTHER-INCOME-CORPORATION-NONRECURRING'],
    memoPy:['OTHER-INCOME-CORPORATION-ZERO', 'OTHER-INCOME-CORPORATION-NONRECURRING']
  },
  depreciation: { id: "depreciation", name: "Depreciation (1120)"},
  depletion: { id: "depletion", name: "Depletion"},
  amortization: { id: "amortization", name: "Amortization (1120)"},
  amortization4562: { id: "amortization4562", fieldId: "amortization4562", name: "Amortization (4562)"},
  casualtyTheftLoss: { id: "casualtyTheftLoss", name: "Casualty/theft loss"},
  extraordinaryOneTimeExpenses: { id: "extraordinaryOneTimeExpenses", name: "Extraordinary one-time expenses"},
  netOperatingLossDeduction: { id: "netOperatingLossDeduction", name: "Net operating loss"},
  specialDeductions: { id: "specialDeductions", name: "Special deductions"},
  mortgagesNotesPayableLessThanOneYearEndOfYear: { id: "mortgagesNotesPayableLessThanOneYearEndOfYear", fieldId: "mortgagesNotesPayableLess1YrEndOfTaxYear", name: "Mortgages, notes or bonds payable in less than 1 year",
    memoCy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-CURRENT-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-CORPORATION-CURRENT-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH'],
    memoPy:['MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-ALL-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-NONE-EXCLUDED-PRIOR-YEAR',
      'MORTGAGES-NOTES-BONDS-PAYABLE-LESS-THAN-ONE-YEAR-SOME-EXCLUDED-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-EXCLUDED-EXCEEDS-AMOUNT-CORPORATION-PRIOR-YEAR', 'MORTGAGES-NOTES-BONDS-SUFFICIENT-CASH']
  },
  travelEntertainment: { id: "travelEntertainment", name: "Travel and entertainment (M-1)", changeOverYearFromTaxReturn: true},
  deductibleMeals: { id: "deductibleMeals", fieldId: "mealsAndEntertainment", name: "Meals and entertainment (M-3)", changeOverYearFromTaxReturn: true},
  cashDistributions: { id: "cashDistributions", name: "Cash distributions"},
  totalBusinessIncome: { id: "totalBusinessIncome", name: "Subtotal Business Income"},
  ownershipPercent: { id: "ownershipPercent", fieldId: "cyAllocationPercentage", name: "Borrower's Ownership Percent"},
  totalBusinessIncomeShare: { id: "totalBusinessIncomeShare", name: "Borrower's Share of Business Income"},
  w2MedicareWages: { id: "w2MedicareWages", name: "W-2 Medicare wages"},
  compensationOfOfficers: { id: "compensationOfOfficers", name: "Compensation of Officers",
    memoCy:['COMPENSATION-OF-OFFICERS-NOT-ON-1040'],
    memoPy:['COMPENSATION-OF-OFFICERS-NOT-ON-1040']
  }
}

const SeFindingsCasualtyTheftLossLineType = {
  casualtyTheftNonIncomePropertyShortTermGainLossAmount: {id: "casualtyTheftNonIncomePropertyShortTermGainLossAmount", name: "Gain or loss from non-income producing property held one year or less"},
  casualtyTheftIncomePropertyShortTermLossAmount: {id: "casualtyTheftIncomePropertyShortTermLossAmount", name: "   Loss from income producing property held one year or less"},
  casualtyTheftLongTermGainAmount: {id: "casualtyTheftLongTermGainAmount", name: "Gain from property held more than one year"},
  casualtyTheftLongTermLossAmount: {id: "casualtyTheftLongTermLossAmount", name: "Loss from property held more than one year"},
}

const SeFindingsCmpIncomeAnalysisLineType = {
  grossReceiptsOrSales: {id: "grossReceiptsOrSales", name: "Gross Receipts or Sales",
    fieldLoc: {
      soleProprietorship: {formId: SeTaxFormType.tf1040c, fieldId: "grossReceiptsOrSales"},
      sCorp: {formId: SeTaxFormType.tf1120s, fieldId: "grossReceiptsOrSales"},
      partnership: {formId: SeTaxFormType.tf1065, fieldId: "grossReceiptsOrSales"},
      corp: {formId: SeTaxFormType.tf1120, fieldId: "grossReceiptsOrSales"},
    }
  },
  returnsAndAllowances: {id: "returnsAndAllowances", name: "Returns and Allowances",
    fieldLoc: {
      soleProprietorship: {formId: SeTaxFormType.tf1040c, fieldId: "returnsAndAllowances"},
      sCorp: {formId: SeTaxFormType.tf1120s, fieldId: "returnsAndAllowances"},
      partnership: {formId: SeTaxFormType.tf1065, fieldId: "returnsAndAllowances"},
      corp: {formId: SeTaxFormType.tf1120, fieldId: "returnsAndAllowances"}
    }
  },
  grossIncome: {id: "grossIncome", name: "Gross Income"},
  costOfGoodsSold: {id: "costOfGoodsSold", name: "Cost of Goods Sold",
    fieldLoc: {
      soleProprietorship: {formId: SeTaxFormType.tf1040c, fieldId: "costOfGoodsSold"},
      sCorp: {formId: SeTaxFormType.tf1120s, fieldId: "costOfGoodsSold"},
      partnership: {formId: SeTaxFormType.tf1065, fieldId: "costOfGoodsSold"},
      corp: {formId: SeTaxFormType.tf1120, fieldId: "costOfGoodsSold"}
    }
  },
  totalDeductions: {id: "totalDeductions", name: "Total Deductions",
    fieldLoc: {
      soleProprietorship: {formId: SeTaxFormType.tf1040c, fieldId: "totalExpenses"},
      sCorp: {formId: SeTaxFormType.tf1120s, fieldId: "totalDeductions"},
      partnership: {formId: SeTaxFormType.tf1065, fieldId: "totalDeductions"},
      corp: {formId: SeTaxFormType.tf1120, fieldId: "totalDeductions"}
    }
  },
  expenses: {id: "expenses", name: "Expenses"},
  expenseIncomePercent: {id: "expenseIncomePercent", name: "Expenses / Gross Income"},
  taxableIncome: {id: "taxableIncome", name: "Taxable Income",
    fieldLoc: {
      soleProprietorship: {formId: SeTaxFormType.tf1040c, fieldId: "netProfitLoss"},
      sCorp: {formId: SeTaxFormType.tf1120s, fieldId: "ordinaryBusinessIncomeLoss"},
      partnership: {formId: SeTaxFormType.tf1065, fieldId: "ordinaryBusinessIncomeLoss"},
      corp: {formId: SeTaxFormType.tf1120, fieldId: "taxableIncome"}
    }
  },
  taxableIncomePercent: {id: "taxableIncomePercent", name: "Taxable Income / Gross Income"}
}

const MortgagePayableLess1YrRolloverType = {
  all: "All",
  some: "Some",
  none: "None"
}

const SeScheduleEPartnershipSCorpType = {
  s: "S",
  p: "P"
}

const SeAnalysisResultType = {
  needsReview: "Needs Review",
  satisfactory: "Satisfactory"
}

const SePartnerType = {
  generalPartner: "General Partner or LLC member-manager",
  limitedPartner: "Limited Partner or other LLC member",
  none: "There is no selection on this line"
}

// ---------------------------------------------------------------------------
// Wage Earner enums (IuWageData* schemas in se-api.yml)
// ---------------------------------------------------------------------------

// IuWageDocumentationType — RESTRICTED to these 3 values for this UI
const SeWageDocumentationType = {
  yearToDatePayStub: 'yearToDatePayStub',
  yearEndPayStub: 'yearEndPayStub',
  w2Form: 'w2Form'
}
const SeWageDocumentationTypeLabel = {
  yearToDatePayStub: 'Year To Date Pay Stub',
  yearEndPayStub: 'Year End Pay Stub',
  w2Form: 'W2 Form'
}

// IuWageDocumentationSourceType — full set
const SeWageDocumentationSourceType = {
  aggregator: 'aggregator',
  borrower: 'borrower',
  directEmployer: 'directEmployer',
  internalRevenueService: 'internalRevenueService',
  payrollProvider: 'payrollProvider',
  other: 'other'
}
const SeWageDocumentationSourceTypeLabel = {
  aggregator: 'Aggregator',
  borrower: 'Borrower',
  directEmployer: 'Direct Employer',
  internalRevenueService: 'Internal Revenue Service',
  payrollProvider: 'Payroll Provider',
  other: 'Other'
}

// IuEmployeeStatusType — RESTRICTED to these 3 values for this UI
const SeEmployeeStatusType = {
  active: 'active',
  inactive: 'inactive',
  notStarted: 'notStarted'
}
const SeEmployeeStatusTypeLabel = {
  active: 'Active',
  inactive: 'Inactive',
  notStarted: 'Not Started'
}

// IuEmploymentStatusType — full set
const SeEmploymentStatusType = {
  current: 'current',
  previous: 'previous'
}
const SeEmploymentStatusTypeLabel = {
  current: 'Current',
  previous: 'Previous'
}

// IuWageDataIncomeItemCategoryType — full set (used for both PayRate.category and IncomeItem.category)
const SeWageIncomeItemCategoryType = {
  // automobileAllowance: 'automobileAllowance',
  base: 'base',
  bonus: 'bonus',
  commissions: 'commissions',
  // contractBasis: 'contractBasis',
  overtime: 'overtime',
  tips: 'tips',
  // housingAllowance: 'housingAllowance',
  // militaryEntitlements: 'militaryEntitlements',
  // mortgageDifferential: 'mortgageDifferential',
  notQualifyingIncome: 'notQualifyingIncome',
  // restrictedStockUnits: 'restrictedStockUnits',
  // reimbursement: 'reimbursement',
  relocation: 'relocation'
}
const SeWageIncomeItemCategoryTypeLabel = {
  // automobileAllowance: 'Automobile Allowance',
  base: 'Base Pay',
  bonus: 'Bonus',
  commissions: 'Commissions',
  // contractBasis: 'Contract Basis',
  overtime: 'Overtime',
  tips: 'Tips',
  // housingAllowance: 'Housing Allowance',
  // militaryEntitlements: 'Military Entitlements',
  // mortgageDifferential: 'Mortgage Differential',
  notQualifyingIncome: 'Other Not Qualifying Income',
  // restrictedStockUnits: 'Restricted Stock Units',
  // reimbursement: 'Reimbursement',
  relocation: 'Relocation'
}

// IuWageDataIncomeItemMilitaryCategoryType — full set
const SeWageIncomeItemMilitaryCategoryType = {
  activeDutyPay: 'activeDutyPay',
  assignmentIncentivePay: 'assignmentIncentivePay',
  basicAllowanceForHousing: 'basicAllowanceForHousing',
  basicAllowanceForSubsistance: 'basicAllowanceForSubsistance',
  basicPay: 'basicPay',
  basicNeedsAllowance: 'basicNeedsAllowance',
  clothesAllowance: 'clothesAllowance',
  combatPay: 'combatPay',
  familySeparationAllowance: 'familySeparationAllowance',
  familySupplementalSubsistenceAllowance: 'familySupplementalSubsistenceAllowance',
  flightPay: 'flightPay',
  hardshipDutyPay: 'hardshipDutyPay',
  hazardousDutyIncentivePay: 'hazardousDutyIncentivePay',
  hostileFireImminentDangerPay: 'hostileFire_ImminentDangerPay',
  notQualifyingIncome: 'notQualifyingIncome',
  overseasPay: 'overseasPay',
  overseasCostOfLivingAllowance: 'overseasCostOfLivingAllowance',
  quartersAllowance: 'quartersAllowance',
  rationsAllowance: 'rationsAllowance',
  reserveDrillPay: 'reserveDrillPay',
  variableHousingAllowance: 'variableHousingAllowance'
}
const SeWageIncomeItemMilitaryCategoryTypeLabel = {
  activeDutyPay: 'Active Duty Pay',
  assignmentIncentivePay: 'Assignment Incentive Pay',
  basicAllowanceForHousing: 'Basic Allowance For Housing',
  basicAllowanceForSubsistance: 'Basic Allowance For Subsistence',
  basicPay: 'Basic Pay',
  basicNeedsAllowance: 'Basic Needs Allowance',
  clothesAllowance: 'Clothes Allowance',
  combatPay: 'Combat Pay',
  familySeparationAllowance: 'Family Separation Allowance',
  familySupplementalSubsistenceAllowance: 'Family Supplemental Subsistence Allowance',
  flightPay: 'Flight Pay',
  hardshipDutyPay: 'Hardship Duty Pay',
  hazardousDutyIncentivePay: 'Hazardous Duty Incentive Pay',
  hostileFireImminentDangerPay: 'Hostile Fire / Imminent Danger Pay',
  notQualifyingIncome: 'Not Qualifying Income',
  overseasPay: 'Overseas Pay',
  overseasCostOfLivingAllowance: 'Overseas Cost Of Living Allowance',
  quartersAllowance: 'Quarters Allowance',
  rationsAllowance: 'Rations Allowance',
  reserveDrillPay: 'Reserve Drill Pay',
  variableHousingAllowance: 'Variable Housing Allowance'
}

// IuEmployeePayFrequencyType — full set
const SeEmployeePayFrequencyType = {
  annual: 'annual',
  biweekly: 'biweekly',
  daily: 'daily',
  hourly: 'hourly',
  monthly: 'monthly',
  perTask: 'perTask',
  perTrip: 'perTrip',
  quarterly: 'quarterly',
  semiannual: 'semiannual',
  semimonthly: 'semimonthly',
  timesPerYear: 'timesPerYear',
  unknown: 'unknown',
  weekly: 'weekly'
}
const SeEmployeePayFrequencyTypeLabel = {
  annual: 'Annual',
  biweekly: 'Biweekly',
  daily: 'Daily',
  hourly: 'Hourly',
  monthly: 'Monthly',
  perTask: 'Per Task',
  perTrip: 'Per Trip',
  quarterly: 'Quarterly',
  semiannual: 'Semiannual',
  semimonthly: 'Semimonthly',
  timesPerYear: 'Times Per Year',
  unknown: 'Unknown',
  weekly: 'Weekly'
}

// IuEmployeePayCycleType — full set (same as PayFrequency minus 'hourly')
const SeEmployeePayCycleType = {
  annual: 'annual',
  biweekly: 'biweekly',
  daily: 'daily',
  monthly: 'monthly',
  perTask: 'perTask',
  perTrip: 'perTrip',
  quarterly: 'quarterly',
  semiannual: 'semiannual',
  semimonthly: 'semimonthly',
  timesPerYear: 'timesPerYear',
  unknown: 'unknown',
  weekly: 'weekly'
}
const SeEmployeePayCycleTypeLabel = {
  annual: 'Annual',
  biweekly: 'Biweekly',
  daily: 'Daily',
  monthly: 'Monthly',
  perTask: 'Per Task',
  perTrip: 'Per Trip',
  quarterly: 'Quarterly',
  semiannual: 'Semiannual',
  semimonthly: 'Semimonthly',
  timesPerYear: 'Times Per Year',
  unknown: 'Unknown',
  weekly: 'Weekly'
}

// IuEmployeeBasisType — full set
const SeEmployeeBasisType = {
  fixed: 'fixed',
  variable: 'variable',
  other: 'other'
}
const SeEmployeeBasisTypeLabel = {
  fixed: 'Fixed',
  variable: 'Variable',
  other: 'Other'
}

// IuEmployeePeriodMonthType — full set
const SeEmployeePeriodMonthType = {
  january: 'january',
  february: 'february',
  march: 'march',
  april: 'april',
  may: 'may',
  june: 'june',
  july: 'july',
  august: 'august',
  september: 'september',
  october: 'october',
  november: 'november',
  december: 'december'
}
const SeEmployeePeriodMonthTypeLabel = {
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December'
}

// IuWageDataIncomeItemCategoryType — full read-only set used by the Findings Report for
// Wage Earner responses (unlike SeWageIncomeItemCategoryType above, which is the subset the
// user can pick from on the Pay Rate / Income Item forms, this includes every category the
// backend can return, e.g. contractBasis, automobileAllowance, etc). Order below matches the
// declaration order of WageEarnerCategoryDescription.java, which drives sort order on reports.
const SeWageResponseCategoryOrder = [
  'base', 'overtime', 'bonus', 'commissions', 'contractBasis', 'tips',
  'automobileAllowance', 'housingAllowance', 'restrictedStockUnits', 'mortgageDifferential',
  'militaryEntitlements', 'reimbursement', 'relocation', 'notQualifyingIncome'
]
const SeWageResponseCategoryTypeLabel = {
  base: 'Base Income',
  overtime: 'Overtime',
  bonus: 'Bonus',
  commissions: 'Commissions',
  contractBasis: 'Contract Basis',
  tips: 'Tips',
  automobileAllowance: 'Automobile Allowance',
  housingAllowance: 'Housing Allowance',
  restrictedStockUnits: 'Restricted Stock Units',
  mortgageDifferential: 'Mortgage Differential',
  militaryEntitlements: 'Military Entitlements',
  reimbursement: 'Reimbursement',
  relocation: 'Relocation',
  notQualifyingIncome: 'Not Qualifying Income'
}
// Categories excluded from the "eligible" income category totals in the Income Details
// section (mirrors WageEarnerReportBuilder.ineligibleIncomeCategories)
const SeWageIneligibleIncomeCategories = ['notQualifyingIncome', 'reimbursement', 'relocation']

// IuWageDataIncomeCategoryMethodType — full set
const SeWageCategoryMethodTypeLabel = {
  averagePriorYear: 'Average Prior Year',
  averageYearToDate: 'Average Year To Date',
  averageYearToDatePlusPriorYear: 'Average Year To Date Plus Prior Year',
  fixedPeriodAmount: 'Fixed Period Amount',
  hourlyRate: 'Hourly Rate',
  seeMessages: 'See Messages'
}

// IuWageDataIncomeCategoryTrendType — full set
const SeWageCategoryTrendTypeLabel = {
  increasing: 'Increasing',
  decreasing: 'Decreasing',
  stable: 'Stable',
  unableToDetermine: 'Unable To Determine'
}

export default {
  SeStatus, SeRequestType, SeUserType, SeYesNoType, SeIncomeTypeType, SeEmploymentType, SeEmploymentClassificationType,
  SeTaxFormType, SeBusinessStructureType, SeEvalRequestYearsType, SeFindingsSummaryLineType, SeFindingsSummaryRentalSchELineType,
  MortgagePayableLess1YrRolloverType, SeFindingsCasualtyTheftLossLineType,
  SeScheduleEPartnershipSCorpType, SeFindingsCmpIncomeAnalysisLineType, SeFindingsSummarySCorpLineType,
  SeAnalysisResultType, SeEvaluationDataSourceType, SePartnerType, SeFindingsSummaryPartnershipLineType,
  SeFindingsSummaryCorpLineType, SeMonthlyQualifiedIncomeZeroMemos, SePYQualifiedIncomeZeroMemos, EmploymentOwnershipInterestProvidedType,
  SeRentalIncomeIrsFormType, SeRentalPropertyType, SeFairRentalDaysLessThan365DetailType, SeRentalMonthlyQualifiedIncomeZeroMemos,
  SeAdjustedRentalIncomeMemos,
  SeWageDocumentationType, SeWageDocumentationTypeLabel,
  SeWageDocumentationSourceType, SeWageDocumentationSourceTypeLabel,
  SeEmployeeStatusType, SeEmployeeStatusTypeLabel,
  SeEmploymentStatusType, SeEmploymentStatusTypeLabel,
  SeWageIncomeItemCategoryType, SeWageIncomeItemCategoryTypeLabel,
  SeWageIncomeItemMilitaryCategoryType, SeWageIncomeItemMilitaryCategoryTypeLabel,
  SeEmployeePayFrequencyType, SeEmployeePayFrequencyTypeLabel,
  SeEmployeePayCycleType, SeEmployeePayCycleTypeLabel,
  SeEmployeeBasisType, SeEmployeeBasisTypeLabel,
  SeEmployeePeriodMonthType, SeEmployeePeriodMonthTypeLabel,
  SeWageResponseCategoryOrder, SeWageResponseCategoryTypeLabel, SeWageIneligibleIncomeCategories,
  SeWageCategoryMethodTypeLabel, SeWageCategoryTrendTypeLabel
}
